var map = {
	"./Features-Block-Navigate-DA-DK-D.avif": 57994,
	"./Features-Block-Navigate-DE-DE-D.avif": 45596,
	"./Features-Block-Navigate-EN-GB-D.avif": 55610,
	"./Features-Block-Navigate-EN-US-D.avif": 10935,
	"./Features-Block-Navigate-ES-ES-D.avif": 17022,
	"./Features-Block-Navigate-ES-MX-D.avif": 77871,
	"./Features-Block-Navigate-FR-FR-D.avif": 13642,
	"./Features-Block-Navigate-IT-IT-D.avif": 50748,
	"./Features-Block-Navigate-NB-NO-D.avif": 1789,
	"./Features-Block-Navigate-NL-NL-D.avif": 71970,
	"./Features-Block-Navigate-PL-PL-D.avif": 718,
	"./Features-Block-Navigate-PT-BR-D.avif": 24934,
	"./Features-Block-Navigate-PT-PT-D.avif": 20238,
	"./Features-Block-Navigate-SV-SE-D.avif": 34793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32944;